import { MeetingResponse, createTeamsPayload } from '../features/meeting/MeetingTypes';
import { updateTeamsPayload } from '../features/teams/teamsTypes';
import { del, get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';


const fetch_meeting = '/{0}/{1}/appMeeting.list';
const create_meeting = '/{0}/appMeeting.add';
const delete_meeting = '/{0}/{1}/appMeeting.delete';
const update_meeting = '/{0}/{1}/appMeeting.update';
const fetch_meeting_details = '/{0}/{1}/appMeeting.detail';


const credentialsConfig = {
    withCredentials: true,
}


export const fetchMeetingData = async (baseId: number, appId: number): Promise<MeetingResponse> => {
    const fetch_meeting_data = formatUrl(fetch_meeting, [baseId, appId]);
    return get<MeetingResponse>(fetch_meeting_data, credentialsConfig);
};


export const createMeetingData = async (data: createTeamsPayload, userId: number): Promise<MeetingResponse> => {
    const base_create_meeting = formatUrl(create_meeting, [userId]);
    return post<MeetingResponse>(base_create_meeting, data, credentialsConfig);
};

export const deleteMeeting = async (baseId: number, id: number): Promise<MeetingResponse> => {
    const formattedUrl = formatUrl(delete_meeting, [baseId, id]);
    return del<MeetingResponse>(formattedUrl, credentialsConfig);
};

export const updateMeeting = async (baseId: number, id: number, data: updateTeamsPayload): Promise<MeetingResponse> => {
    const formattedUrl = formatUrl(update_meeting, [baseId, id]);
    return put<MeetingResponse>(formattedUrl, data, credentialsConfig);
};

export const fetchMeetingDetails = async (baseId: number, id: number): Promise<MeetingResponse> => {
    const formattedUrl = formatUrl(fetch_meeting_details, [baseId, id]);
    return get<MeetingResponse>(formattedUrl, credentialsConfig);
};

